import findResult, { findWithCodes } from '@/utils/resultsHelper';
import { datasetSettingsCategories } from '../../settings/constants';

const initialState = {
  datasetMetrics: {
    open: {
      results: [],
    },
  },
};

export const findDatasetMetrics = ({ datasetMetrics }, { category, code }) => (
  findResult(datasetMetrics, category, code)
);

export const findAllDatasetMetrics = ({ datasetMetrics }, { items }) => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(datasetMetrics, datasetSettingsCategories, codes);
};

export default initialState;
